import React from 'react';
import { Box } from '@mui/material';
import { Link, useLocation } from 'react-router-dom';
import { useTheme } from '@mui/material/styles';

interface LogoProps {
  isSticky: boolean;
  textColor: string;
  mobile?: boolean;
}

const Logo: React.FC<LogoProps> = ({ isSticky, textColor, mobile = false }) => {
  const location = useLocation();
  const theme = useTheme();
  // Invert logo color for light theme (make it dark)
  const isDarkLogo = theme.palette.mode === 'light';

  const handleClick = (e: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
    if (location.pathname === '/') {
      e.preventDefault();
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  };

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        height: mobile ? 44 : 80,
        transition: 'margin 0.3s ease-in-out',
      }}
    >
      <Link
        to="/"
        onClick={handleClick}
        style={{
          display: 'flex',
          alignItems: 'center',
          height: mobile ? 44 : 80,
        }}
      >
        <img
          src="/logos/logo_white_smooth.svg"
          alt="Yuzhen logo"
          loading="eager"
          decoding="async"
          fetchPriority="high"
          style={{
            height: mobile ? 38 : '95%',
            maxWidth: mobile ? 42 : 'none',
            objectFit: 'contain',
            filter: isDarkLogo ? 'brightness(0)' : 'none',
            transition: 'opacity 0.3s ease-in-out',
          }}
        />
      </Link>
    </Box>
  );
};

export default Logo;
